module.exports = __webpack_public_path__ + "img/logo.18d28a97.svg";